export default __webpack_public_path__ + "static/media/express.75fff9be.svg";